const locales = [
  {
    Name: 'KOR',
    Value: 'ko',
    Label: 'KOR'
  },
  {
    Name: 'ENG',
    Value: 'en',
    Label: 'ENG'
  }
]

export default {
  setLocaleName (name) {
    sessionStorage.setItem('localeName', name)
  },
  getLocaleName () {
    const name = sessionStorage.getItem('localeName')
    return name != null ? name : 'KOR'
  },
  getLocales () {
    return locales
  },

  getLocale () {
    const locale = sessionStorage.getItem('locale')
    return locale != null ? locale : 'ko'
  },

  setLocale (locale) {
    sessionStorage.setItem('locale', locale)
  },

  formatCurrency () {
    const locale = sessionStorage.getItem('locale')

    if (locale === 'ko') {
      return '#,##0 원'
    } else if (locale === 'en') {
      return '$ #,##0.'
    } else if (locale === 'jp') {
      return '¥ #,##0.'
    } else {
      return '#,##0'
    }
  },

  formatDate () {
    const locale = sessionStorage.getItem('locale')

    if (locale === 'ko') {
      return 'yyyy-MM-dd HH:mm:SS'
    } else if (locale === 'en') {
      return 'MM/dd/yyyy'
    } else {
      return 'yyyy-MM-dd'
    }
  },

  auiFormatDate () {
    const locale = sessionStorage.getItem('locale')

    if (locale === 'ko') {
      return 'yyyy-mm-dd HH:MM:ss'
    } else if (locale === 'en') {
      return 'mm/dd/yyyy HH:MM:ss'
    } else {
      return 'yyyy-mm-dd HH:MM:ss'
    }
  },

  auiSpsFormatDate () {
    const locale = sessionStorage.getItem('locale')

    if (locale === 'ko') {
      return 'yyyy-mm-dd HH:MM:ss'
    } else if (locale === 'en') {
      return 'mm/dd/yyyy HH:MM:ss'
    } else {
      return 'yyyy-mm-dd HH:MM:ss'
    }
  }
}



// WEBPACK FOOTER //
// ./src/locale/bos-locale.js